<template>
  <fragment>
    <span :id="targetKey" class="text-center">{{ visibleText }}</span>
    <b-tooltip v-if="!isTextFullyVisible" :delay="delay" :target="targetKey">
      {{ text }}
    </b-tooltip>
  </fragment>
</template>

<script>
export default {
  name: 'LongStringWithTooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 32,
    },
    delay: {
      type: Number,
      default: 200,
    },
    targetKey: {
      type: String,
      default: 'visible-text',
    },
  },
  computed: {
    visibleText: function () {
      if (this.isTextFullyVisible) return this.text;
      return `${(this.text || '').substring(0, this.length)}...`;
    },
    isTextFullyVisible: function () {
      return (this.text || '').length <= this.length;
    },
  },
};
</script>

<style scoped></style>
